/** @jsxImportSource @emotion/react */

import { useParams } from "react-router";
import { Divider } from "../../../../components/Divider";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { MutateAdyenAccountHolderForm } from "../../components/MutateAdyenAccountHolderForm";
import { useGetAdyenAccountHolder } from "../../service/adyen-account-holders-api";
import { SpinnerBlock } from "../../../common/Spinner";

export const EditAdyenAccountHolderPage = () => {
  const { id } = useParams();
  const { data: accountHolder, isLoading } = useGetAdyenAccountHolder(id);

  return (
    <RouteFullScreenModal title="Edit Adyen account holder">
      <Divider />
      {isLoading || !accountHolder ? (
        <SpinnerBlock />
      ) : (
        <MutateAdyenAccountHolderForm adyenAccountHolder={accountHolder} />
      )}
    </RouteFullScreenModal>
  );
};
